import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  PrivacyOptOutButtonContainer,
  PrivacyOptOutContainer,
  PrivacyOptOutTextContainer,
} from './styles';
import Button from '../../common/button/button.component';
import {
  HeaderSecondary,
  LinkSmall,
} from '../../common/typography/typography.styles';
import { useStore } from '../../stores/store';

const PrivacyOptOut = () => {
  const {
    localizationsStore: { selectedCountry },
  } = useStore();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBackClick = () => {
    navigate(-1);
  };

  return (
    <PrivacyOptOutContainer>
      <PrivacyOptOutButtonContainer>
        <Button
          icon={{
            glyph: 'chevron-left',
            color: 'dark',
            position: 'left',
          }}
          onClick={handleGoBackClick}
          appearance='text'>
          {t('back')}
        </Button>
      </PrivacyOptOutButtonContainer>
      <PrivacyOptOutTextContainer>
        <HeaderSecondary>{t('do_not_share_page_header')}</HeaderSecondary>
        <p>{t('do_not_share_page_title')}</p>
        <p>{t('do_not_share_page_text_p1')}</p>
        <p>
          {
            <Trans
              i18nKey='do_not_share_page_text_p2'
              components={{
                // eslint-disable-next-line
                1: (
                  <LinkSmall
                    target='_blank'
                    rel='noopener noreferrer'
                  />
                ),
              }}
              values={{
                cookieSettingsLink: '#',
              }}
            />
          }
        </p>
        <p>
          {
            <Trans
              i18nKey='do_not_share_page_text_p3'
              components={{
                // eslint-disable-next-line
                1: (
                  <LinkSmall
                    target='_blank'
                    rel='noopener noreferrer'
                  />
                ),
              }}
              values={{
                privacyLink: selectedCountry?.links?.privacy_policy,
              }}
            />
          }
        </p>
        <p>
          {
            <Trans
              i18nKey='do_not_share_page_text_p4'
              components={{
                // eslint-disable-next-line
                1: (
                  <LinkSmall
                    target='_blank'
                    rel='noopener noreferrer'
                  />
                ),
              }}
              values={{
                privacyLink: selectedCountry?.links?.privacy_policy,
              }}
            />
          }
        </p>
      </PrivacyOptOutTextContainer>
    </PrivacyOptOutContainer>
  );
};

export default observer(PrivacyOptOut);
